import React from 'react';
import { Button } from './ui/Button';
import { Mail, ArrowRight } from 'lucide-react';
export function CTA() {
  return <section id="contact" className="py-24 bg-slate-900 text-white" data-id="element-11">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-12">
        <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-13">
          Ready to Transform Your <br data-id="element-14" />
          Document Review?
        </h2>
        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-15">
          Get a quote and time estimate within 24 hours. No software to install,
          no complex onboarding.
        </p>

        <div className="bg-slate-800/50 rounded-2xl p-8 md:p-12 border border-slate-700 backdrop-blur-sm" data-id="element-16">
          <h3 className="text-lg font-medium text-white mb-8" data-id="element-17">
            To proceed, please provide:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 text-left" data-id="element-18">
            <div className="flex items-start" data-id="element-19">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-amber-500 font-bold mr-3" data-id="element-20">
                1
              </div>
              <p className="text-slate-300 text-sm" data-id="element-21">
                Discovery export (load file + extracted text/natives)
              </p>
            </div>
            <div className="flex items-start" data-id="element-22">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-amber-500 font-bold mr-3" data-id="element-23">
                2
              </div>
              <p className="text-slate-300 text-sm" data-id="element-24">
                Delivery preference (Excel file or Web Platform)
              </p>
            </div>
            <div className="flex items-start" data-id="element-25">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-amber-500 font-bold mr-3" data-id="element-26">
                3
              </div>
              <p className="text-slate-300 text-sm" data-id="element-27">
                Any specific requirements or concerns
              </p>
            </div>
          </div>

          <Button size="lg" className="w-full md:w-auto min-w-[200px] text-lg" onClick={() => window.location.href = 'mailto:contact@evantiq.com'} data-id="element-28">
            <Mail className="mr-2 h-5 w-5" data-id="element-29" />
            Contact Us to Get Started
          </Button>
          <p className="mt-4 text-sm text-slate-500" data-id="element-30">
            Typical response time: &lt; 24 hours
          </p>
        </div>
      </div>
    </section>;
}